<template>
  <div class="otodetusercol">
    <div class="lawbf">
      <div class="lawbaincov">
        <img src="../../../assets/case/aaaa1_sample.png" alt="" />
      </div>
      <div class="lawnme">杨洋律师</div>
      <div class="lawzhiwei">合伙人律师</div>
      <div class="shuju between">
        <div>
          <div class="shuzi">1856</div>
          <div class="status">已帮助</div>
        </div>
        <div class="sx"></div>
        <div>
          <div class="shuzi">1856</div>
          <div class="status">已帮助</div>
        </div>
      </div>
      <div class="zxbtn notextselect">咨询我</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.otodetusercol {
  width: 280px;
  height: 364px;
  padding: 75px 0 0;
  background: url("../../../assets/case/otodetusercolbg.png") no-repeat;
  .lawbf {
    width: 230px;
    height: 255px;
    margin: 0 auto;
    padding: 50px 32px 0;
    background-color: #fff;
    text-align: center;
    position: relative;
    .lawbaincov {
      position: absolute;
      top: -48px;
      left: 70px;
      img {
        width: 90px;
        height: 90px;
        border-radius: 50%;
      }
    }
    .lawnme {
      font-size: 20px;
      color: #333333;
    }
    .lawzhiwei {
      font-size: 12px;
      color: #999999;
    }
    .shuju {
      margin-top: 32px;
      .shuzi {
        font-size: 22px;
        line-height: 22px;
        color: #333333;
      }
      .status {
        margin-top: 8px;
        font-size: 12px;
        color: #999999;
      }
      .sx {
        width: 1px;
        height: 40px;
        background: #c8c8c8;
      }
    }
    .zxbtn {
      cursor: pointer;
      width: 160px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      margin: 32px auto 0;
      border: 1px solid #0465ea;
      border-radius: 15px;
      font-size: 16px;
      color: #0465ea;
    }
  }
}
</style>